import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '~/components/ui/button';

export type TemplateVariableKey =
  | 'applicantName'
  | 'jobTitle'
  | 'jobEmployer'
  | 'inviteUrl'
  | 'jobLocation'
  | 'jobDescription'
  | 'recruiterName';

interface Props {
  onInsert: (variable: string) => void;
  disabled?: boolean;
  variables: readonly TemplateVariableKey[];
}

export function TemplateVariableButtons({ onInsert, disabled, variables }: Props): React.ReactNode {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap gap-2">
      {variables.map((key) => (
        <Button
          key={key}
          type="button"
          variant="outline"
          size="xs"
          disabled={disabled}
          onClick={() => {
            onInsert(`{{${key}}}`);
          }}
        >
          <Plus className="size-3" />
          {t(`communications.variables.${key}`)}
        </Button>
      ))}
    </div>
  );
}

/**
 * Replace {{variable}} placeholders with example preview values.
 */
export function renderPreview(template: string): string {
  const examples: Partial<Record<TemplateVariableKey, string>> = {
    applicantName: 'John Doe',
    jobTitle: 'Warehouse Associate',
    jobEmployer: 'Acme Corp',
    inviteUrl: 'https://app.example.com/invite/abc123',
    jobLocation: 'New York, NY',
    jobDescription: 'Full-time warehouse position...',
    recruiterName: 'Sara'
  };
  return template.replace(/\{\{(\w+)\}\}/g, (_match, key: string) => {
    return examples[key as TemplateVariableKey] ?? `{{${key}}}`;
  });
}
